module.exports = __webpack_public_path__ + "img/mobile-16.482a340e.png";